export enum Locales {
  EN = 'en',
  BN_BN = 'bn'
}

export enum MenuTypes {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical"
}

export enum MenuTypeKey {
  DASHBOARD = "menu_type_dash",
  BLOG = "menu_type_blog"
}

export enum Theme {
  LIGHT = "light",
  DARK = "dark"
}

export enum ThemeKey {
  DASHBOARD = "theme_dashboard",
  BLOG = "theme_blog"
}
